<template>
  <div style="height: 415px">
    <l-map ref="wapimap" :zoom="13" :center="center" style="z-index: 100">
      <l-tile-layer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"></l-tile-layer>
      <l-geo-json ref="geoJsonLayer" :geojson="value" :options="geoJsonOptions" />
      <l-control :position="'topright'"></l-control>
    </l-map>
  </div>
</template>

<script>
import settings from "../settings.json";

export default {
  name: "wapi-geo-json-map",
  props: {
    value: {
      type: [Array, Object],
      default: function() {
        return {};
      }
    },
    geojson: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      showOptions: true,
      center: settings.center,
      map: null,
      geoJsonOptions: {
        onEachFeature: (feature, layer) => {
          const bounds = layer.getBounds();
          layer.getLatLng = function() {
            return this.getBounds().getCenter();
          };
          layer.setLatLng = function() {};
          layer._latlng = layer.getLatLng();
          this.$refs.wapimap.mapObject.fitBounds(bounds);
        }
      }
    };
  },
  mounted() {
    this.map = this.$refs.wapimap.mapObject;
    const mapObject = this.map;
    const drawnItems = new window.L.FeatureGroup();
    this.drawnItems = drawnItems;
    const drawControlFull = new window.L.Control.Draw({
      draw: {
        polygon: true,
        marker: false,
        polyline: false,
        rectangle: false,
        circle: false,
        circlemarker: false
      },
      edit: {
        featureGroup: drawnItems
      }
    });

    const drawControlEditOnly = new window.L.Control.Draw({
      draw: {
        polygon: false,
        marker: false,
        polyline: false,
        rectangle: false,
        circle: false,
        circlemarker: false
      },
      edit: {
        featureGroup: drawnItems
      }
    });

    this.drawControlFull = drawControlFull;
    this.drawControlEditOnly = drawControlEditOnly;

    const nextTickFunc = () => {
      mapObject.addLayer(drawnItems);
      mapObject.addControl(drawControlFull);

      mapObject.on(window.L.Draw.Event.CREATED, e => {
        const layer = e.layer;
        const geoJSON = layer.toGeoJSON();
        drawnItems.addLayer(layer);

        mapObject.removeControl(drawControlFull);
        mapObject.addControl(drawControlEditOnly);
        this.$emit("input", geoJSON);
      });

      mapObject.on("draw:deleted", () => {
        if (drawnItems.getLayers().length === 0) {
          mapObject.removeControl(drawControlEditOnly);
          mapObject.addControl(drawControlFull);
          this.$emit("input", {});
        }
      });
    };
    this.$nextTick(nextTickFunc);
  },
  watch: {
    value(val) {
      if (val) {
        const geoJson = window.L.geoJSON(val);
        const layer = geoJson.getLayers()[0];

        this.drawnItems.addLayer(layer);
        this.map.fitBounds(layer.getBounds());
        this.map.removeControl(this.drawControlFull);
        this.map.addControl(this.drawControlEditOnly);
      } else {
        this.drawnItems.clearLayers();

        this.map.removeControl(this.drawControlEditOnly);
        this.map.addControl(this.drawControlFull);
      }
    }
  }
};
</script>